import { type IPlaybookPage } from "../../app-utils/playbook.js";
import { type ParentType } from "../../graphql.js";
import { SelectorIcons } from "../../settings/assets-settings.js";
import PlaybookWizard from "../playbooks/PlaybookWizard.js";
import AddParentTypeScreen from "./AddParentTypeScreen.js";

export interface IAddParentTypeDialogProps {
  title: string;
  parentType?: ParentType; // editing case

  onApply: () => void;
  onClose: () => void;
}

const AddParentTypeDialog = (props: IAddParentTypeDialogProps) => {
  const dialogScreen: Partial<IPlaybookPage> = {
    label: props.parentType ? "Edit Parent Type Data" : "Enter Data for New Parent Type",
  };

  return (
    <PlaybookWizard
      title={props.title}
      steps={[dialogScreen]}
      mapStepToScreen={(p) => <AddParentTypeScreen playbookPage={p} parentType={props.parentType} />}
      onClose={props.onClose}
      icon={SelectorIcons.CONFIG}
    />
  );
};

export default AddParentTypeDialog;
